import { fMap as m, some as g, none as p, isEmpty as y, optional as d } from "@hprofits/utils/fp/optional";
import "zod";
import { AssertionError as E } from "../errors/errors.js";
import "../schemas.js";
import { geoSubRuleConflictsWithTarget as G, osSubRuleConflictsWithTarget as P } from "./hierarchicalTargetMatch.js";
import { RuleTypeEnumSchema as f, DimensionTypeSchema as V, SingleScheduledDimensionOutputSchema as v, SingleScheduledDimensionInputSchema as W, SingleGeoDimensionOutputSchema as b, SingleGeoDimensionInputSchema as R, SingleDomainDimensionOutputSchema as D, SingleDomainDimensionInputSchema as x, SingleSpotDimensionOutputSchema as w, SingleSpotDimensionInputSchema as J, SingleLanguageDimensionOutputSchema as I, SingleLanguageDimensionInputSchema as K, SingleBrowserDimensionOutputSchema as O, SingleBrowserDimensionInputSchema as _, SingleDeviceDimensionOutputSchema as C, SingleDeviceDimensionInputSchema as B, SingleOsDimensionOutputSchema as $, SingleOsDimensionInputSchema as U, SingleIpDimensionOutputSchema as k, SingleIpDimensionInputSchema as q, SingleKeywordDimensionOutputSchema as T, SingleKeywordDimensionInputSchema as A, SingleCategoryDimensionOutputSchema as N, SingleCategoryDimensionInputSchema as F, SingleContentTypeDimensionOutputSchema as j, SingleContentTypeInputSchema as H, SingleStartStopDimensionOutputSchema as M, SingleStartStopDimensionInputSchema as Q, OtherDimensionsSchema as X } from "./schemas.js";
const i = (e, s) => e.length === s.length && e.every((n) => s.includes(n)) && s.every((n) => e.includes(n)), Y = (e) => ({
  schedule: e.schedule,
  domains: e.domains,
  spots: e.spots,
  ips: e.ips,
  keywords: e.keywords,
  categories: m(e.categories, (s) => ({
    type: s.type,
    values: s.values.map((n) => n.id)
  })),
  contentTypes: m(e.contentTypes, (s) => ({
    type: s.type,
    values: s.values.map((n) => n.name)
  })),
  geo: m(e.geo, (s) => ({
    type: s.type,
    values: s.values.map((n) => ({
      code: n.code,
      regionCodes: n.regions?.map((t) => t.code)
    }))
  })),
  languages: m(e.languages, (s) => ({
    type: s.type,
    values: s.values.map((n) => n.code)
  })),
  browsers: m(e.browsers, (s) => ({
    type: s.type,
    values: s.values.map((n) => n.id)
  })),
  devices: m(e.devices, (s) => ({
    type: s.type,
    values: s.values.map((n) => n.id)
  })),
  os: m(e.os, (s) => ({
    type: s.type,
    values: s.values.map((n) => ({
      typeId: n.typeId,
      oses: n.oses?.map((t) => ({
        id: t.id,
        versionIds: t.versions?.map((a) => a.id)
      }))
    }))
  }))
}), de = (e) => {
  if (e === "other")
    return "other";
  if ("time" in e) {
    const { start: t, end: a } = e.time;
    return { time: { start: t, end: a } };
  }
  const s = Y(e), n = Object.keys(s).find((t) => s[t] !== void 0);
  if (!n)
    throw new Error(
      `dimensionOutputToInput: no recognized dimension key in ${JSON.stringify(Object.keys(e))} — buildDimensionsInput returned an empty aggregate`
    );
  return { [n]: s[n] };
}, l = (e, s, n) => (t, a) => {
  if (!e || !s)
    return p();
  const r = e.safeParse(t), o = s.safeParse(a);
  return r.success && o.success ? g(n(r.data, o.data)) : p();
}, ge = (e, s) => {
  if (!e && !s)
    return g(!0);
  if (!e || !s)
    return g(!1);
  const n = [
    l(
      W,
      v,
      (t, a) => JSON.stringify(a.schedule) === JSON.stringify(t.schedule)
    ),
    l(
      R,
      b,
      // todo: compare regions
      (t, a) => a.geo.type === t.geo.type && i(
        a.geo.values.map((r) => r.code),
        t.geo.values.map((r) => r.code)
      ) && i(
        a.geo.values.flatMap((r) => d(r.regions)?.map((o) => o.code) ?? []),
        t.geo.values.flatMap((r) => d(r.regionCodes) ?? [])
      )
    ),
    l(
      x,
      D,
      (t, a) => a.domains.type === t.domains.type && i(a.domains.values, t.domains.values)
    ),
    l(
      J,
      w,
      (t, a) => a.spots.type === t.spots.type && i(a.spots.values, t.spots.values)
    ),
    l(
      K,
      I,
      (t, a) => a.languages.type === t.languages.type && i(
        a.languages.values.map((r) => r.code),
        t.languages.values
      )
    ),
    l(
      _,
      O,
      (t, a) => a.browsers.type === t.browsers.type && // todo: compare versions
      i(
        a.browsers.values.map((r) => r.id),
        t.browsers.values.map((r) => r)
      )
    ),
    l(
      B,
      C,
      (t, a) => a.devices.type === t.devices.type && i(
        a.devices.values.map((r) => r.id),
        t.devices.values
      )
    ),
    l(
      U,
      $,
      (t, a) => a.os.type === t.os.type && i(
        a.os.values.map((r) => r.typeId),
        t.os.values.map((r) => r.typeId)
      ) && i(
        a.os.values.flatMap((r) => d(r.oses)?.map((o) => o.id) ?? []),
        t.os.values.flatMap((r) => d(r.oses)?.map((o) => o.id) ?? [])
      ) && i(
        a.os.values.flatMap(
          (r) => d(r.oses)?.flatMap((o) => d(o.versions)?.map((S) => S.id) ?? []) ?? []
        ),
        t.os.values.flatMap((r) => d(r.oses)?.flatMap((o) => d(o.versionIds) ?? []) ?? [])
      )
    ),
    l(
      q,
      k,
      (t, a) => a.ips.type === t.ips.type && i(a.ips.values, t.ips.values)
    ),
    l(
      A,
      T,
      (t, a) => a.keywords.type === t.keywords.type && i(a.keywords.values, t.keywords.values)
    ),
    l(
      F,
      N,
      (t, a) => a.categories.type === t.categories.type && i(
        a.categories.values.map((r) => r.id),
        t.categories.values
      )
    ),
    l(
      H,
      j,
      (t, a) => a.contentTypes.type === t.contentTypes.type && i(
        a.contentTypes.values.map((r) => r.name),
        t.contentTypes.values
      )
    ),
    l(
      Q,
      M,
      (t, a) => t.time.start === a.time.start && t.time.end === a.time.end
    )
  ];
  for (const t of n) {
    const a = t(s, e);
    if (a !== void 0)
      return g(a);
  }
  return p();
}, Z = (e) => e === "other" ? g("other") : "time" in e ? g("time") : V.options.find((s) => s in e), ee = (e, s) => {
  if (e === "schedule" || e === "os" || s === "other")
    return p();
  const t = s[e]?.values;
  if (!t || t.length === 0)
    return p();
  const a = /* @__PURE__ */ new Set();
  for (const r of t)
    switch (e) {
      case "geo":
        a.add(
          String(r.code).trim().toUpperCase()
        );
        break;
      case "languages":
        a.add(String(r).trim().toLowerCase());
        break;
      case "domains":
        a.add(String(r).trim().toLowerCase());
        break;
      case "keywords":
        a.add(String(r).trim().toLowerCase());
        break;
      case "contentTypes":
        a.add(String(r).trim().toLowerCase());
        break;
      case "ips":
        a.add(String(r).trim());
        break;
      // `DictCategoryId` is a branded STRING (e.g. "IAB1"); the numeric coercion the other
      // id dimensions use turned every category into "NaN" on both sides, so no category
      // ever compared as out of range.
      case "categories":
        a.add(String(r).trim());
        break;
      case "browsers":
      case "devices":
      case "spots":
        a.add(String(Number(r)));
        break;
    }
  return a;
}, L = (e, s) => {
  if (e === "schedule" || e === "os")
    return p();
  if (e === "other" || e === "time")
    return p();
  const n = s[e];
  if (!n || typeof n != "object" || !("type" in n))
    return p();
  const t = n.values;
  if (!t || t.length === 0)
    return p();
  const a = /* @__PURE__ */ new Set();
  for (const r of t)
    switch (e) {
      case "geo":
        a.add(
          String(r.code).trim().toUpperCase()
        );
        break;
      case "languages":
        a.add(
          String(r.code).trim().toLowerCase()
        );
        break;
      case "browsers":
      case "devices":
        a.add(String(Number(r.id)));
        break;
      case "domains":
        a.add(String(r).trim().toLowerCase());
        break;
      case "keywords":
        a.add(String(r).trim().toLowerCase());
        break;
      case "contentTypes":
        a.add(
          String(r.name).trim().toLowerCase()
        );
        break;
      case "ips":
        a.add(String(r).trim());
        break;
      // Mirrors the input side: the category's own string id, not a numeric coercion of the
      // whole `{ id, name }` entry, which produced "NaN" for every value.
      case "categories":
        a.add(String(r.id).trim());
        break;
      case "spots":
        a.add(String(Number(r)));
        break;
    }
  return { type: n.type, values: a };
}, Se = (e, s) => {
  const n = L(e, s);
  return n?.type === f.enum.include ? n.values : p();
}, se = (e, s) => {
  if (e === "other")
    return p();
  if ("geo" in e) {
    const n = s.geo;
    return n !== void 0 && G(e.geo.values, n.type, n.values);
  }
  if ("os" in e) {
    const n = s.os;
    return n !== void 0 && P(e.os.values, n.type, n.values);
  }
  return p();
}, te = (e, s, n) => {
  const t = L(e, n), a = ee(e, s);
  return y(t) || y(a) ? !1 : t.type === f.enum.include ? [...a].some((r) => !t.values.has(r)) : [...a].some((r) => t.values.has(r));
}, ye = (e, s) => {
  const n = Z(e);
  return y(n) || n === "other" || n === "time" ? !1 : se(e, s) ?? te(n, e, s);
}, u = (e, s, n) => {
  const t = s.safeParse(e);
  return t.success ? n(t.data) : p();
}, he = (e, s) => {
  const n = (t) => `${t.code}${m(t.regionCodes, (a) => ` (${a.join(", ")})`) ?? ""}`;
  return s.reduce(
    // eslint-disable-next-line sonarjs/no-nested-conditional
    (t, a, r) => t.length > 0 ? `${t}${r > 0 ? "," : ""} ${n(a)}` : n(a),
    e
  );
}, c = (e, s) => ({ dimension: e, name: s }), ae = (e) => e.days.reduce((s, n) => {
  const t = n.hours.reduce((a, r) => a + (1 << r), 0);
  return `${s}${n}[${t}]`;
}, ""), ne = (e) => e.start && e.end ? `${e.start} → ${e.end}` : e.start ? `from ${e.start}` : e.end ? `until ${e.end}` : "", h = (e) => {
  const s = m(e.regions, (n) => n.map((t) => t.name).join(", "));
  return `${e.name}${s ? ` (${s})` : ""}`;
}, re = (e, s) => s.reduce(
  // eslint-disable-next-line sonarjs/no-nested-conditional
  (n, t, a) => n.length > 0 ? `${n}${a > 0 ? "," : ""} ${h(t)}` : h(t),
  e
), oe = (e) => {
  const s = e.map((n) => {
    const t = n.oses ?? [];
    if (t.length === 0)
      return `t${n.typeId}`;
    const a = t.map((r) => {
      const o = [...new Set(r.versions ?? [])].map((S) => S.name).sort((S, z) => S.localeCompare(z));
      return o.length > 0 ? `o${r.name}v${o.join(".")}` : `o${r.name}`;
    }).sort((r, o) => r.localeCompare(o));
    return `t${n.typeId}-${a.join("_")}`;
  }).sort((n, t) => n.localeCompare(t)).join("__");
  return s.length > 0 ? `os ${s}` : "os";
}, fe = (e) => {
  if (!e)
    throw new E("No dimension provided");
  return u(e, X, (s) => c(s, s)) ?? u(
    e,
    M,
    (s) => c("time", ne(s.time))
  ) ?? u(e, D, (s) => c("domains", s.domains.values.join("|"))) ?? u(
    e,
    v,
    (s) => c("schedule", ae(s.schedule))
  ) ?? u(e, w, (s) => c("spots", s.spots.values.join("|"))) ?? u(
    e,
    b,
    (s) => c("geo", re("", s.geo.values))
  ) ?? u(
    e,
    I,
    (s) => c("languages", s.languages.values.join("|"))
  ) ?? u(
    e,
    O,
    (s) => c("browsers", s.browsers.values.join("|"))
  ) ?? u(e, C, (s) => c("devices", s.devices.values.join("|"))) ?? u(
    e,
    $,
    (s) => c("os", oe(s.os.values))
  ) ?? u(e, k, (s) => c("ips", s.ips.values.join("|"))) ?? u(
    e,
    T,
    (s) => c("keywords", s.keywords.values.join("|"))
  ) ?? u(
    e,
    N,
    (s) => c("categories", s.categories.values.map((n) => n.id).join("|"))
  ) ?? u(
    e,
    j,
    (s) => c("contentTypes", s.contentTypes.values.map((n) => n.name).join("|"))
  );
}, ve = (e, s) => m(e, (n) => s.safeParse(n).success) ?? !1, be = (e, s) => m(e, (n) => s.safeParse(n).success) ?? !1;
export {
  Y as buildDimensionsInput,
  he as buildGeoInputDimensionName,
  re as buildGeoOutputDimensionName,
  de as dimensionOutputToInput,
  ge as dimensionsEqual,
  ee as extractNormalizedInputValues,
  L as extractNormalizedTargetConstraint,
  Se as extractNormalizedTargetValues,
  Z as extractSubDimensionKey,
  fe as getOutputSubDimensionName,
  ve as isInputDimension,
  be as isOutputDimension,
  u as mapIfMatches,
  ye as subRuleDimensionConflictsWithTarget
};
//# sourceMappingURL=utils.js.map
